import React, { FC } from 'react'
import { makeStyles } from 'transfix-ui/core'

const labelStyles = makeStyles(({ spacing, typography }) => ({
  root: {
    fontSize: typography.h2.fontSize,
    marginLeft: spacing(0.5),
    marginRight: spacing(0.5),
  },
}))

export const Label: FC = ({ children }) => {
  const classes = labelStyles()
  return <span className={classes.root}>{children}</span>
}
